@if (customMessage) {
    <div class="betbuilder-custom-message">{{ customMessage }}</div>
}
